module.exports = __webpack_public_path__ + "img/identidad.f028c6bd.svg";